import { Component, OnInit } from '@angular/core';
import { fciWebsiteService } from './../../../service/fci-website.service';
import { Buffer } from 'buffer';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
declare let $: any;
import { CustomServiceService } from './../../../service/custom-service.service';
import { EncryptDecryptService } from './../../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
})
export class AboutUsComponent implements OnInit {
  language: any = sessionStorage.getItem('locale'); //dynamic
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  constructor(
    private fciwebservice: fciWebsiteService,
    private httpservice: CustomServiceService,
    public translate: TranslateService,
    public encDec: EncryptDecryptService,
    private routerparam: ActivatedRoute,
    private route: Router
  ) {}

  backend_url: any = environment.serviceURL;
  showAbout: boolean = false;
  ngOnInit(): void {
    if (environment.ZONE_ID > 0) {
      this.getZoneAbout(environment.ZONE_ID);
    }
  }

  zone_apirespons: any;
  zoneList: any[] = [];
  zoneDetails: any = {
    title: '',
    titleInHindi: '',
    selectZone: '',
    selectRegion: '',
    readMoreMenuType: '',
    readMoreLinkType: '',
    selectMenu: '',
    description: '',
    descriptionInHindi: '',
    jsonOptTxtDetails: {
      ZONE_ID: 'Headquarter',
      REGION_ID: '--',
      INTMENUTYPE: 'Secondary',
      INTLINKTYPE: 'Content Page',
      MENU_ID: 'Header/Insight/Overview/First Test',
    },
    id: '',
    noOfRec: '',
    backgroundImage: '',
    backgroundImage_details: { fileType: '', fileSize: '' },
  };
  TotalzoneList: number = 0;
  getZoneAbout(zoneid: any) {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 0,
        orderBy: [],
        condition: [
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: '0',
            joinoperator: 'and',
          },
          {
            columnName: 'ZONE_ID',
            operator: '=',
            value: zoneid,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.httpservice
      .getZoneAbout(params)
      .subscribe((response: HttpEvent<any>) => {
        switch (response.type) {
          case HttpEventType.Sent:
            break;
          case HttpEventType.ResponseHeader:
            break;
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.Response:
            this.zone_apirespons = response.body;
            let respData: any = this.zone_apirespons.RESPONSE_DATA;
            let respToken: any = this.zone_apirespons.RESPONSE_TOKEN;
            let verifyToken: any = CryptoJS.HmacSHA256(
              respData,
              environment.apiHashingKey
            ).toString();
            if (respToken == verifyToken) {
              let response_: any = Buffer.from(respData, 'base64');
              response_ = JSON.parse(response_);
              if (response_.status == 200) {
                this.zoneList = response_.result.sec_1;
                this.TotalzoneList = this.zoneList.length;
                if (this.zoneList.length > 0) {
                  this.zoneDetails = response_.result.sec_1[0];
                  this.showAbout = true;
                }
              }
            }
        }
      });
  }

  jsonConvert(data: any, type: any) {
    if (data == '' || data == null) {
      return '';
    }
    if (data.jsonOptTxtDetails == '' || data.jsonOptTxtDetails == null) {
      return '';
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else {
      return '';
    }
  }

  goToContentPage(menuid: any) {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 0,
        orderBy: [],
        condition: [
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: '1',
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'intId',
            operator: '=',
            value: menuid,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice.getAll(params, 'ManageMenu').subscribe((resp: any) => {
      let respData = resp.RESPONSE_DATA;
      let respToken = resp.RESPONSE_TOKEN;

      let verifyToken = CryptoJS.HmacSHA256(
        respData,
        environment.apiHashingKey
      ).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response.toString());
        if (response.status == 200) {
          if (response.result.sec_1.length > 0) {
            const linkType = response.result.sec_1[0].linkType;
            switch (linkType) {
              case 1: //external page
                this.goToExtLink(response.result.sec_1[0].externalLink);
                break;
              case 2: //plugin page
                this.goToPluginPage(response.result.sec_1[0].selectPlugin, {
                  plugin_id: response.result.sec_1[0].id,
                  selectPlugin: response.result.sec_1[0].selectPlugin,
                });
                break;
              case 3: //content page
                this.setSelectedData(response.result.sec_1[0]);
                break;
              case 4: //na
                break;
              default:
              //
            }
          }
        }
      }
    });
  }

  goToExtLink(url: any) {
    Swal.fire({
      title:
        'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }

  goToPluginPage(link: any, menudtl: any) {
    sessionStorage.removeItem(btoa(menudtl.selectPlugin));
    sessionStorage.setItem(btoa(menudtl.selectPlugin), JSON.stringify(menudtl));
    this.route
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.route.navigate([link]));
  }

  setSelectedData(response: any) {
    this.route
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.route.navigate(['./view' + '/' + response.menuAlias]));
  }
}
